import { gql } from 'apollo-boost'

export const BILLING_UPGRADED = gql`
    mutation{
        billingUpgraded
    }
`
